import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

function Class12Reports() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("intermediateAdminToken");

  const [loading, setLoading] = useState(false);
  const [reportCounts, setReportCounts] = useState({});
  const className = sessionStorage.getItem("className");
  useEffect(() => {
    if (!token) {
      navigate("/intermedate-admin");
    }
  }, []);

  /* const fetchReportCounts = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/AdminReportDashboardCount_CL9`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();
      const data = result?.data?.adminDashboardReport_data;

      if (data) {
        setReportCounts({
          "Account Rejected": data.accounT_REJECTED,
          "Account Approved": data.accounT_APPROVED,
          "Account Pending": data.accounT_PENDING,
          "Challan Not Paid": data.challaN_NOT_PAID,
          "All Challan": data.alL_CHALLAN,
          "Challan Not Generated": data.challaN_NOT_GENERATED,
          "Deo Report": data.deO_REPORT,
          "District School Count": data.districT_SCHOOL_COUNT,
        });
      }
    } catch (error) {
      console.error("Failed to fetch report counts", error);
      Swal.fire("Error", "Failed to load dashboard counts", "error");
    } finally {
      setLoading(false);
    }
  }; */

  const reportOptions = [
    {
      label: "Rejected by Accounts",
      url: `${config.API_BASE_URL}/AdminGetFORejectedReportIntermediate`,
      method: "GET",
      dataPath: `data["rejectedReport_list"]`,
      buttonClass: "btn-danger",
    },
    {
      label: "Approved by Accounts",
      url: `${config.API_BASE_URL}/AdminGetFOApprovedReportIntermediate`,
      method: "GET",
      dataPath: `data["approvedReport_list"]`,
      buttonClass: "btn-success",
    },
    {
      label: "Pending at Accounts",
      url: `${config.API_BASE_URL}/AdminGetFOPendingReportIntermediate`,
      method: "GET",
      dataPath: `data["pendingReport_list"]`,
      buttonClass: "btn-primary",
    },
    {
      label: "Payment not Done",
      url: `${config.API_BASE_URL}/AdminFOChlnPendingForSubReportIntermediate`,
      method: "GET",
      dataPath: `data["challanPendingForSubReport_list"]`,
      buttonClass: "btn-info",
    },

    {
      label: "All Challan",
      url: `${config.API_BASE_URL}/AdminGetAllChallanReportIntermediate`,
      method: "GET",
      dataPath: `data["allChallanReport_list"]`,
      buttonClass: "btn-warning",
    },

    {
      label: "Challan Not Generated",
      url: `${config.API_BASE_URL}/AdminChallanNotGenerateReportIntermediate`,
      method: "GET",
      dataPath: `data["adminChallanNotGenerateReport_list"]`,
      buttonClass: "btn-secondary",
    },
    /* {
      label: "District wise student Count",
      url: `${config.API_BASE_URL}/AdminDEOReport_CL9`,
      method: "GET",
      dataPath: `data["adminDEOreport_list"]`,
      buttonClass: "btn-primary",
    }, */
    {
      label: "District wise school wise student count",
      url: `${config.API_BASE_URL}/AdminDistrictSchoolCountIntermediate`,
      method: "GET",
      dataPath: `data["adminDistSchoolCount_list"]`,
      buttonClass: "btn-success",
    },
  ];

  const fetchReportData = async (reportLabel) => {
    const reportConfig = reportOptions.find((r) => r.label === reportLabel);
    if (!reportConfig) {
      Swal.fire("Invalid report type.", "", "error");
      return;
    }

    if (!token) {
      Swal.fire("Auth Error", "Token is missing. Please login.", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(reportConfig.url, {
        method: reportConfig.method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      const extractedData =
        getValueFromPath(result, reportConfig.dataPath) || [];

      if (!extractedData.length) {
        Swal.fire("No data found.", "", "info");
        return;
      }

      generateExcel(extractedData, reportConfig.label);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Error fetching report.", "error");
    } finally {
      setLoading(false);
    }
  };

  const getValueFromPath = (obj, path) => {
    try {
      return path
        .replace(/\[(["']?)([^\[\]"']+)\1\]/g, ".$2")
        .replace(/^\./, "")
        .split(".")
        .reduce((acc, key) => acc?.[key], obj);
    } catch {
      return undefined;
    }
  };

  const generateExcel = (data, title) => {
    try {
      // Only convert keys to UPPERCASE
      const formatHeader = (key) => key.toUpperCase();

      const headers = ["Sl. No.", ...Object.keys(data[0])];
      const formattedHeaders = [
        "SL. NO.",
        ...Object.keys(data[0]).map(formatHeader),
      ];

      const now = new Date();
      const dateStr = `${String(now.getDate()).padStart(2, "0")}-${String(
        now.getMonth() + 1
      ).padStart(2, "0")}-${now.getFullYear()}  ${now
        .toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        })
        .toUpperCase()}`;

      const ws = XLSX.utils.aoa_to_sheet([
        [`Report: ${title}`],
        [`Generated on: ${dateStr}`],
        [],
        formattedHeaders,
      ]);

      const rows = data.map((item, i) => [
        i + 1,
        ...headers.slice(1).map((key) => item[key] ?? ""),
      ]);

      XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

      ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: formattedHeaders.length - 1 } },
      ];

      ws["!cols"] = formattedHeaders.map(() => ({ wch: 20 }));

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Report");

      const safeFileName = `Report_Intermediate_${title.replace(
        /[^a-zA-Z0-9]/g,
        "_"
      )}.xlsx`;
      XLSX.writeFile(wb, safeFileName);

      Swal.fire("Success", "Excel file downloaded", "success");
    } catch (err) {
      console.error("Excel generation failed", err);
      Swal.fire("Error", "Failed to generate Excel", "error");
    }
  };

  return (
    <div className="container-scroller">
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <section className="content-header mb-4">
              <h1>
                <i className="fa fa-university" /> Class XI Reports
              </h1>
              <ol className="breadcrumb">
                <li>
                  <a
                    onClick={() => navigate("/intermediate-admin-dashboard")}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa fa-tachometer mr-2"></i> Home
                  </a>
                </li>
                <li className="active">
                  Intermediate Accounts Reports Class XI
                </li>
              </ol>
            </section>

            <div className="row">
              <div className="col-md-4">
                <div className="card">
                  <div className="card-header bg-green">
                    <h5>Class XI Reports</h5>
                  </div>
                  <div className="card-body">
                    <table className="table">
                      <tbody>
                        {reportOptions.map((report, index) => (
                          <tr key={index}>
                            <td>
                              <button
                                className={`btn ${report.buttonClass} w-100`}
                                style={{ textAlign: "left" }}
                                onClick={() => fetchReportData(report.label)}
                              >
                                <i className="fa fa-download excel-icon-rounded"></i>
                                &nbsp;
                                {report.label}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Class12Reports;
